<template>
  <div class="modal-duplicate-order">
    <div class="modal-head">
      <h4>DUPLICATING ORDER {{ order.order_number }}</h4>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <label class="lb w150">Order Number:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="order-number-seq" v-model="orderNumber" class="custom-control-input" value="seq">
            <label class="custom-control-label" for="order-number-seq">Sequence (#{{ nextSequence }})</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="order-number-new" v-model="orderNumber" class="custom-control-input" value="new">
            <label class="custom-control-label" for="order-number-new">New</label>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="order.job_id">
        <label class="lb w150">Job Number:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-keep" v-model="jobNumber" class="custom-control-input" value="keep">
            <label class="custom-control-label" for="job-number-keep">Keep {{ order.client.code }}{{ order.job_id }}</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-none" v-model="jobNumber" class="custom-control-input" value="none">
            <label class="custom-control-label" for="job-number-none">None</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <button type="button" class="btn btn-outline-black" @click="duplicateOrder">Duplicate</button>
        <button type="button" class="btn btn-outline-gray" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ServiceOrder from '@/services/order'

  export default {
    data () {
      return {
        orderNumber: 'seq',
        jobNumber: 'keep',
        state: ''
      }
    },
    props: ['order', 'on_job_view'],
    watch: {},
    computed: {
      ...mapState({
        sequenceCharacters: state => state.option.sequenceCharacters
      }),
      nextSequence: function(){
        let self = this, index = 0;
        if (self.order.sequence) {
          index = self.sequenceCharacters.indexOf(self.order.sequence) + 1;
        }
        return (self.order.parent_id?self.order.parent_id:self.order.id) + self.sequenceCharacters[index];
      }
    },
    created () {},
    mounted () {},
    methods: {
      init () {

      },
      duplicateOrder () {
        let self = this;
        if ( self.state == 'processing' ) {
          return;
        }
        self.state = 'processing';
        ServiceOrder.clone({ id: self.order.id, orderNumber: self.orderNumber, jobNumber: self.jobNumber }, order => {
          self.state = '';
          self.$notify({
            type: 'success',
            text: 'This order has been cloned. '
          });
          if (self.on_job_view) {
            self.$store.dispatch('ADD_JOB_ORDER', order);
          } else {
            self.$router.push({
              name: 'order',
              params: {
                orderId: order.id
              }
            });
          }
          self.$emit('close');
        });
      }
    }
  }
</script>
